// extracted by mini-css-extract-plugin
export var textInput = "_cp-0";